import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { deleteProductLink } from 'redux/catalog/actions';

import TooltipCommon from 'components/common/TooltipCommon';
import TooltipButton from 'components/elements/buttons/TooltipButton';

import './ProductDeleteIcon.css';


class ProductDeleteIcon extends Component {
  static propTypes = {
    deleteProductLink: PropTypes.func.isRequired,
    productId: PropTypes.number.isRequired,
    device: PropTypes.string.isRequired,
  };

  state = {
    popupOpen: false,
  };

  onPopupClose = () => {
    this.setState({ popupOpen: false });
  };

  renderTooltipContent = () => (
    <Translation>
      {(t) => (
        <div className="tooltip-content">
          <div className="message-text">
            <div>{t("Are you sure you want to delete this product?")}</div>
            <div>{t("You can't undo this action.")}</div>
          </div>

          <div className="buttons-block">
            <TooltipButton
              onClick={() => this.setState({ popupOpen: false })}
            >
              {t("Cancel")}
            </TooltipButton>
            <TooltipButton
              negative
              onClick={() => this.props.deleteProductLink(this.props.productId)}
            >
              {t("Delete")}
            </TooltipButton>
          </div>
        </div>
      )}
    </Translation>
  );

  renderDeleteButtonDesktop = () => (
    <div className="product-delete-icon__component">
      <div
        className="desktop-icon"
        onClick={() => this.setState({ popupOpen: true })}
        role="button"
        tabIndex={-1}
      />
    </div>
  );

  renderDeleteButtonMobile = () => (
    <Translation>
      {(t) => (
        <div className="product-delete-icon__component">
          <div
            className="mobile-icon"
            onClick={() => this.setState({ popupOpen: true })}
            role="button"
            tabIndex={-1}
          >
            <div className="icon" />
            <div className="undertext">{t("Delete")}</div>
          </div>
        </div>
      )}
    </Translation>
  );


  render() {
    return (
      <Translation>
        {(t) => (
          <TooltipCommon
            key={`delete-product-tooltip-key-${this.props.productId}`}
            overlayClassName="delete-product-tooltip__component"
            header={t("Delete Product")}
            placement="bottom"
            trigger="click"
            visible={this.state.popupOpen}
            closeIcon
            onClose={this.onPopupClose}
            overlay={this.renderTooltipContent()}
          >
            {this.props.device === 'desktop' ?
              this.renderDeleteButtonDesktop()
              :
              this.renderDeleteButtonMobile()
            }
          </TooltipCommon>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    device: state.commonReducer.device,
  }
);

export default connect(
  mapStateToProps,
  {
    deleteProductLink,
  },
)(ProductDeleteIcon);
